import actionTypes from "./actionTypes";

export const showLoader = data => {
  return {
    type: actionTypes.SHOW_LOADER,
    payload: data
  };
};

export const hideLoader = data => {
  return {
    type: actionTypes.HIDE_LOADER,
    payload: data
  };
};
